import { useCallback, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftLong } from '@fortawesome/free-solid-svg-icons/faLeftLong';
import { ItemStats, ItemDirectionType } from '@api/shipping-data/types/ItemStats';
import { renderLitresToHL, numberWithSpaces } from 'components/global/utils';
import { getParsedSystemId } from '@utils/getParsedSystemId';



interface GridRowProps {
	item: ItemStats,
	rowIndex: number,
}


const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { materialId, materialName, itemDirection, orderReasonCodes,
		orderCount, orderCountReducedPpas, orderCountReducedCustomer,
		orderVolume, orderVolumeReducedPpas, orderVolumeReducedCustomer,
		deliveryCount, deliveryCountReducedPpas,
		deliveryVolume, deliveryVolumeReducedPpas,
		deliveredCount, deliveredCountReducedPpas,
		deliveredVolume, deliveredVolumeReducedPpas } = props.item;

	const columnWithArrow = itemDirection !== ItemDirectionType.toSale;
	const isSeparatedOrder = orderReasonCodes.some(x => x === 'sap_Z1');

	
	const getClassName = useCallback((centered: boolean) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			centered ? ' centered-cell' : ''
		}${
			isSeparatedOrder ? ' separated-order' : ''
		}`
	,[ rowIndex, itemDirection, isSeparatedOrder ]);


	return (
		<>
			<div className={`${getClassName(true)}${columnWithArrow ? ' column-with-arrow' : ''}`}>
				{columnWithArrow &&
					<FontAwesomeIcon className='type-icon' icon={faLeftLong} />}
				<p>{materialId ? getParsedSystemId(materialId).clientId : '-'}</p>
			</div>

			<div className={getClassName(false)}>
				<p>{materialName ? materialName : '-'}</p>
			</div>

			<div className={getClassName(false)}>
				{`${
					orderCount !== null && orderCount !== undefined ? numberWithSpaces(orderCount) : '-'
				}${
					(orderCountReducedPpas || orderCountReducedCustomer) ? '!' : ''
				}/${
					deliveryCount !== null && deliveryCount !== undefined ? numberWithSpaces(deliveryCount) : '-'
				}${
					deliveryCountReducedPpas ? '!' : ''
				}/${
					deliveredCount !== null && deliveredCount !== undefined ? numberWithSpaces(deliveredCount) : '-'
				}${
					deliveredCountReducedPpas ? '!' : ''
				}`}
			</div>

			<div className={getClassName(false)}>
				{`${
					orderVolume !== null && orderVolume !== undefined ? renderLitresToHL(orderVolume, 2) : '-'
				}${
					(orderVolumeReducedPpas || orderVolumeReducedCustomer) ? '!' : ''
				}/${
					deliveryVolume !== null && deliveryVolume !== undefined ? renderLitresToHL(deliveryVolume, 2) : '-'
				}${
					deliveryVolumeReducedPpas ? '!' : ''
				}/${
					deliveredVolume !== null && deliveredVolume !== undefined ? renderLitresToHL(deliveredVolume, 2) : '-'
				}${
					deliveredVolumeReducedPpas ? '!' : ''
				}`}
			</div>
		</>
	)
}

export default memo(GridRow);